export function extractPhoneDigits(value: string): string {
  return value.replace(/\D/g, "").slice(0, 11);
}

export function normalizePhoneForSubmit(digits: string): string | null {
  if (digits.length === 10) {
    return `+7${digits}`;
  }

  if (
    digits.length === 11 &&
    (digits.startsWith("7") || digits.startsWith("8"))
  ) {
    return `+7${digits.slice(1)}`;
  }

  return null;
}

export function formatPhoneDigits(
  digits: string
): { formatted: string; valid: boolean } {
  let localDigits = digits;
  if (digits.startsWith("7") || digits.startsWith("8")) {
    localDigits = digits.slice(1);
  }

  let formatted = "";
  if (digits.length > 0) formatted = "+7";
  if (localDigits.length > 0) formatted += ` (${localDigits.slice(0, 3)}`;
  if (localDigits.length >= 3) formatted += ")";
  if (localDigits.length > 3) formatted += ` ${localDigits.slice(3, 6)}`;
  if (localDigits.length > 6) formatted += `-${localDigits.slice(6, 8)}`;
  if (localDigits.length > 8) formatted += `-${localDigits.slice(8, 10)}`;

  return {
    formatted,
    valid: normalizePhoneForSubmit(digits) !== null,
  };
}
